import React, {useEffect, useState} from 'react';
import {
    Progress,
    Tag,
    Divider,
    Collapse,
    InputNumber,
    Button,
    message,
    notification,
    Modal,
    Form,
    Input,
    Select
} from 'antd';
import {
    CaretRightOutlined,
    DeleteOutlined, EditOutlined,
    ExclamationCircleFilled,
    ShopOutlined,
    ShoppingCartOutlined
} from '@ant-design/icons';
import axios from 'axios';
import {production} from "../../API/API";
const { Panel } = Collapse;
const { confirm } = Modal;
const { Option } = Select;
const instance = axios.create({
    baseURL: 'https://gdapp.org/API/4.0/',
    timeout: 10000,
});

const EditProductModal = ({ visible, onClose, onUpdate, product }) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    // Список единиц измерения
    const unitOptions = [
        { value: 'шт', label: 'шт' },
        { value: 'Kg', label: 'Kg' },
        { value: 'g', label: 'g' },
        { value: 'L', label: 'L' },
        { value: 'ml', label: 'ml' },
        { value: 'M', label: 'M' },
        { value: 'sm', label: 'sm' },
        { value: 'M2', label: 'M²' }
    ];

    // Заполняем форму данными при открытии
    useEffect(() => {
        if (visible && product) {
            form.setFieldsValue({
                brand: product.brand,
                name: product.name,
                cost: product.cost,
                description: product.description || '',
                package_name: product.package_name || 'шт',
                package: product.package || 1,
                date_available: product.date_avalible || ''
            });
        }
    }, [visible, product, form]);

    const handleSubmit = async (values) => {
        setLoading(true);

        try {
            const formData = new FormData();
            formData.append('id', product.id);
            formData.append('brand', values.brand);
            formData.append('name', values.name);
            formData.append('cost', values.cost);
            formData.append('description', values.description || '');
            formData.append('package_name', values.package_name || 'шт');
            formData.append('date_available', values.date_available || '');
            formData.append('package', values.package || 1);

            const response = await instance.post('store/update_product.php', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });

            if (response.data.success) {
                message.success('Позиция успешно обновлена');

                const updatedProduct = {
                    ...product,
                    brand: values.brand,
                    name: values.name,
                    cost: values.cost,
                    description: values.description || '',
                    package_name: values.package_name || 'шт',
                    package: values.package || 1,
                    date_avalible: values.date_available || ''
                };

                onUpdate(updatedProduct);
                onClose();
            } else {
                message.error(response.data.error || 'Ошибка при обновлении');
            }
        } catch (error) {
            console.error('Error updating product:', error);
            message.error('Ошибка при обновлении позиции');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            title={`Редактировать позицию: ${product?.name}`}
            open={visible}
            onCancel={onClose}
            footer={null}
            width={600}
        >
            <Form
                form={form}
                layout="vertical"
                onFinish={handleSubmit}
            >
                <Form.Item
                    name="brand"
                    label="Бренд"
                    rules={[{ required: true, message: 'Введите бренд' }]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    name="name"
                    label="Название"
                    rules={[{ required: true, message: 'Введите название' }]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    name="cost"
                    label="Цена"
                    rules={[{ required: true, message: 'Введите цену' }]}
                >
                    <InputNumber min={0} step={0.01} style={{ width: '100%' }} />
                </Form.Item>

                <Form.Item
                    name="description"
                    label="Описание"
                >
                    <Input.TextArea rows={3} />
                </Form.Item>

                <Form.Item
                    name="package_name"
                    label="Единица измерения"
                >
                    <Select placeholder="Выберите единицу измерения" defaultValue={'шт'}>
                        {unitOptions.map(unit => (
                            <Option key={unit.value} value={unit.value}>
                                {unit.label}
                            </Option>
                        ))}
                    </Select>
                </Form.Item>

                <Form.Item
                    name="package"
                    label="Количество в упаковке"
                >
                    <InputNumber min={0} style={{ width: '100%' }} />
                </Form.Item>

                <Form.Item
                    name="date_available"
                    label="Годен до:"
                >
                    <Input type="date" />
                </Form.Item>

                <Form.Item>
                    <Button type="primary" htmlType="submit" loading={loading} style={{ marginRight: 8 }}>
                        Сохранить
                    </Button>
                    <Button onClick={onClose}>
                        Отмена
                    </Button>
                </Form.Item>
            </Form>
        </Modal>
    );
};

const StoreProgressBars = ({ item: initialItem, stores = [], showAll = false, onUpdate, username, onDelete }) => {
    const [purchaseQuantity, setPurchaseQuantity] = useState(1);
    const [purchaseLoading, setPurchaseLoading] = useState(false);
    const [deleteLoading, setDeleteLoading] = useState(false);
    const [localItem, setLocalItem] = useState(initialItem);
    const [editModalVisible, setEditModalVisible] = useState(false);

    // Обновляем локальное состояние, когда изменяется проп item
    useEffect(() => {
        setLocalItem(initialItem);
    }, [initialItem]);

    if (!localItem) return null;

    // Функция для закупки товара
    const handlePurchase = async () => {
        if (purchaseQuantity <= 0) {
            message.error('Введите корректное количество');
            return;
        }

        setPurchaseLoading(true);

        try {
            const formData = new FormData();
            formData.append('item_id', localItem.id);
            formData.append('from_store', 'закупка');
            formData.append('to_store', '1');
            formData.append('quantity', purchaseQuantity);
            formData.append('owner', username);
            formData.append('description', `Закупка товара в количестве ${purchaseQuantity}`);
            formData.append('date', Date.now().toString());

            const response = await axios.post(`https://gdapp.org/API/${production ? '4.0' : '4.0_test'}/store/post_transfer.php`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
                withCredentials: true
            });

            if (response.data.success) {
                notification.success({
                    message: 'Закупка выполнена',
                    description: `Товар "${localItem.name}" закуплен в количестве ${purchaseQuantity}`,
                    placement: 'topRight',
                });

                // Сбрасываем количество
                setPurchaseQuantity(1);

                // Обновляем локальное состояние - увеличиваем количество на складе Будва
                const updatedItem = {
                    ...localItem,
                    store_1: (parseFloat(localItem.store_1) || 0) + parseFloat(purchaseQuantity)
                };
                setLocalItem(updatedItem);

                // Вызываем callback для обновления данных в родительском компоненте
                if (onUpdate) {
                    onUpdate(updatedItem);
                }
            } else {
                message.error(response.data.error || 'Ошибка при закупке');
            }
        } catch (error) {
            console.error('Purchase error:', error);
            message.error(error.response?.data?.error || 'Ошибка при закупке');
        } finally {
            setPurchaseLoading(false);
        }
    };

    // Функция для удаления товара
    const handleDelete = () => {
        confirm({
            title: 'Вы уверены, что хотите удалить этот товар?',
            icon: <ExclamationCircleFilled />,
            content: `Товар: ${localItem.name || localItem.brand || 'Без названия'}\nID: ${localItem.id}`,
            okText: 'Да, удалить',
            okType: 'danger',
            cancelText: 'Отмена',
            onOk: async () => {
                setDeleteLoading(true);
                try {
                    const formData = new FormData();
                    formData.append('item_id', localItem.id);
                    const response = await axios.post('https://gdapp.org/API/4.0/store/delete_item.php', formData, {
                        headers: {'Content-Type': 'multipart/form-data'},
                    });

                    if (response.data.success) {
                        notification.success({
                            message: 'Товар удален',
                            description: `Товар "${localItem.name}" успешно удален из системы`,
                            placement: 'topRight',
                        });

                        // Вызываем callback для обновления данных в родительском компоненте
                        if (onDelete) {
                            onDelete(localItem.id);
                        }
                    } else {
                        message.error(response.data.error || 'Ошибка при удалении товара');
                    }
                } catch (error) {
                    console.error('Delete error:', error);
                    message.error(error.response?.data?.error || 'Ошибка при удалении товара');
                } finally {
                    setDeleteLoading(false);
                }
            },
        });
    };

    // Получаем все склады из объекта localItem и исключаем склады 8, 9, 10, 11
    const allStoreKeys = Object.keys(localItem).filter(key => {
        if (key.startsWith('store_') && typeof localItem[key] === 'number') {
            const storeId = key.replace('store_', '');
            return storeId !== '8' && storeId !== '12' && storeId !== '10' && storeId !== '11';
        }
        return false;
    });

    // Фильтруем только активные склады
    const activeStoreKeys = allStoreKeys.filter(storeKey => {
        const storeId = storeKey.replace('store_', '');
        const storeInfo = stores.find(store => +store.name_db == storeId || store.id === parseInt(storeId));
        return storeInfo && storeInfo.enable === "1";
    });

    // Вычисляем общий остаток только по активным складам
    const totalStock = activeStoreKeys.reduce((sum, key) => {
        return sum + (parseFloat(localItem[key]) || 0);
    }, 0);

    const storeData = activeStoreKeys.map(storeKey => {
        const storeId = storeKey.replace('store_', '');
        const storeInfo = stores.find(store => +store.name_db == storeId || store.id === parseInt(storeId));

        return {
            key: storeKey,
            id: storeId,
            name: storeInfo ? storeInfo.name : `Склад ${storeId}`,
            color: storeInfo?.color || getRandomColor(storeId),
            value: parseFloat(localItem[storeKey]) || 0,
            hasStock: parseFloat(localItem[storeKey]) > 0
        };
    });

    // Сортируем по количеству (по убыванию)
    const sortedStores = [...storeData].sort((a, b) => b.value - a.value);

    // Разделяем на склады с наличием и без
    const storesWithStock = sortedStores.filter(store => store.hasStock);
    const storesWithoutStock = sortedStores.filter(store => !store.hasStock);

    return (
        <div>
            {/* Шапка с общей информацией */}
            <div style={{
                padding: '16px',
                background: '#f5f5f5',
                borderBottom: '1px solid #d9d9d9',
                marginBottom: '20px',
                display: 'flex',
                flexWrap: 'nowrap',
                justifyContent: 'space-between',
                alignItems: 'flex-start',
                gap: '16px',
            }}>
                {/* Левая часть - информация о товаре */}
                <div style={{ flex: 1 }}>
                    <div style={{ marginBottom: '8px' }}>
                        <strong>Общий остаток: </strong>
                        <span style={{
                            fontSize: '18px',
                            fontWeight: 'bold',
                            color: totalStock > 0 ? '#389e0d' : '#d4380d'
                        }}>
                            {totalStock}
                        </span>
                    </div>

                    {localItem.category && (
                        <div style={{ marginBottom: '4px' }}>
                            <strong>Категория: </strong>
                            {localItem.category}
                        </div>
                    )}

                    {localItem.brand && (
                        <div style={{ marginBottom: '4px' }}>
                            <strong>Бренд: </strong>
                            {localItem.brand}
                        </div>
                    )}

                    {localItem.description && (
                        <div style={{ marginBottom: '4px' }}>
                            <strong>Описание: </strong>
                            <span style={{ color: '#666' }}>
                                {localItem.description.length > 100
                                    ? `${localItem.description.substring(0, 100)}...`
                                    : localItem.description
                                }
                            </span>
                        </div>
                    )}

                    {localItem.name && !localItem.description && (
                        <div style={{ marginBottom: '4px' }}>
                            <strong>Название: </strong>
                            <span style={{ color: '#666' }}>
                                {localItem.name.length > 100
                                    ? `${localItem.name.substring(0, 100)}...`
                                    : localItem.name
                                }
                            </span>
                        </div>
                    )}

                    {/* Кнопка удаления */}
                    <div style={{ marginTop: '16px' }}>
                        <Button
                            type="primary"
                            onClick={() => setEditModalVisible(true)}
                            icon={<EditOutlined />}
                            style={{marginRight: '10px'}}
                        >
                            Редактировать
                        </Button>
                        <Button
                            type="primary"
                            danger
                            icon={<DeleteOutlined />}
                            loading={deleteLoading}
                            onClick={handleDelete}
                        >
                            Удалить товар
                        </Button>
                    </div>
                </div>

                {/* Правая часть - закупка */}
                <div style={{
                    background: '#e6f7ff',
                    borderRadius: '6px',
                    border: '1px solid #91d5ff',
                    padding: '16px',
                    minWidth: '300px'
                }}>
                    <div style={{ marginBottom: '8px', fontWeight: 'bold' }}>
                        <ShoppingCartOutlined /> Закупка на склад Будва
                    </div>
                    <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                        <InputNumber
                            min={0.01}
                            step={0.01}
                            value={purchaseQuantity}
                            onChange={setPurchaseQuantity}
                            placeholder="Количество"
                            style={{ width: '120px' }}
                        />
                        <Button
                            type="primary"
                            icon={<ShoppingCartOutlined />}
                            loading={purchaseLoading}
                            onClick={handlePurchase}
                            disabled={purchaseQuantity <= 0}
                        >
                            Закупить
                        </Button>
                    </div>
                </div>
            </div>

            {storesWithStock.length === 0 ? (
                <div style={{ padding: '8px', textAlign: 'center', color: '#999' }}>
                    <ShopOutlined /> Нет наличия на складах
                </div>
            ) : (
                <div style={{ padding: '8px', maxHeight: '400px', overflowY: 'auto' }}>
                    {/* Склады с наличием */}
                    {storesWithStock.map((store, index) => (
                        <div key={store.key} style={{ marginBottom: '12px' }}>
                            <StoreProgressItem
                                store={store}
                                maxValue={Math.max(...storesWithStock.map(s => s.value))}
                                showValue={true}
                            />
                            {index < storesWithStock.length - 1 && (
                                <Divider style={{ margin: '8px 0' }} />
                            )}
                        </div>
                    ))}

                    {/* Склады без наличия */}
                    {showAll && storesWithoutStock.length > 0 && (
                        <Collapse
                            bordered={false}
                            expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}
                            style={{ background: '#fafafa', marginTop: '16px' }}
                        >
                            <Panel header={`Склады без наличия (${storesWithoutStock.length})`} key="1">
                                {storesWithoutStock.map(store => (
                                    <div key={store.key} style={{ marginBottom: '8px', opacity: 0.6 }}>
                                        <StoreProgressItem
                                            store={store}
                                            maxValue={0}
                                            showValue={false}
                                        />
                                    </div>
                                ))}
                            </Panel>
                        </Collapse>
                    )}
                </div>
            )}
            <EditProductModal
                visible={editModalVisible}
                onClose={() => setEditModalVisible(false)}
                onUpdate={onUpdate}
                product={localItem}
            />
        </div>
    );
};

// Вспомогательная функция для генерации цвета
const getRandomColor = (seed) => {
    const colors = [
        '#1890ff', '#52c41a', '#faad14', '#f5222d', '#722ed1',
        '#fa541c', '#13c2c2', '#eb2f96', '#a0d911', '#2f54eb'
    ];
    return colors[seed % colors.length];
};



// Компонент для отдельной строки склада
const StoreProgressItem = ({ store, maxValue, showValue }) => (
    <>
        <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: '4px'
        }}>
            <Tag
                color={store.color}
                style={{
                    margin: 0,
                    minWidth: '100px',
                    textAlign: 'center',
                    fontWeight: 'bold',
                    fontSize: '12px'
                }}
            >
                {store.name}
            </Tag>

            {showValue && (
                <span style={{
                    fontWeight: 'bold',
                    minWidth: '60px',
                    textAlign: 'right',
                    fontSize: '12px'
                }}>
                    {store.value.toFixed(2)}
                </span>
            )}
        </div>

        {maxValue > 0 && (
            <Progress
                percent={(store.value / maxValue) * 100}
                showInfo={false}
                size="small"
                strokeColor={store.color}
                style={{ margin: 0 }}
            />
        )}
    </>
);



export default StoreProgressBars;